// Polyfills

// import 'ie-shim'; // Internet Explorer 9 support

// import 'core-js/es6';
// Added parts of es6 which are necessary for your project or your browser support requirements.
(window as any).global = window;
import 'core-js/es6/symbol';
import 'core-js/es6/object';
import 'core-js/es6/function';
import 'core-js/es6/parse-int';
import 'core-js/es6/parse-float';
import 'core-js/es6/number';
import 'core-js/es6/math';
import 'core-js/es6/string';
import 'core-js/es6/date';
import 'core-js/es6/array';
import 'core-js/es6/regexp';
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/es6/weak-map';
import 'core-js/es6/weak-set';
import 'core-js/es6/typed';
import 'core-js/es6/reflect';
import 'core-js/es7/array'; // for .includes()

// see issue https://github.com/AngularClass/angular2-webpack-starter/issues/709
// import 'core-js/es6/promise';
import 'core-js/es6/array';

(window as any).__Zone_enable_cross_context_check = true;
// import 'core-js/es6/reflect';
import 'zone.js/dist/zone';
import 'zone.js';
import 'reflect-metadata';
/** IE10 and IE11 requires the following for NgClass support on SVG elements */
import 'classlist.js';  // Run `npm install --save classlist.js`.

/** IE10 and IE11 requires the following for the Reflect API. */
// import 'core-js/es/reflect';


import 'web-animations-js';  // Run `npm install --save web-animations-js`.
// import 'intl'; // Run npm install --save intl.
// import 'intl/locale-data/jsonp/en';

if (process.env.ENV === 'build') {
    // Production

} else {

    // Development
    Error.stackTraceLimit = Infinity;

    /* tslint:disable no-var-requires */
    require('zone.js/dist/long-stack-trace-zone');
}
